import React from 'react'
import { isMobile } from 'react-device-detect'

const PendingConnectionDetailItem = (props) => {
    return (
        <div className='row py-3 px-0 align-items-center text-center text-md-left'>
            <div className='col-12 col-md-4'>{props.item.title}</div>
            <div className={`col-12 col-md-2 offset-md-3 ${isMobile ? 'bold mt-2' : ''}`}>{props.item.date}</div>
            <div className='col-6 col-md-1 offset-md-1 mt-3 mt-md-0 d-none d-md-block'>
                {props.item.email
                    ? <a href={props.item.email} target='_blank'>
                        <img src='/images/icon-email.svg' />
                      </a>
                    : ''}
            </div>
            <div className='col-6 col-md-1 mt-3 mt-md-0 d-none d-md-block'>
                {props.item.sms
                    ? <a href={props.item.sms} target='_blank'>
                        <img src='/images/icon-sms.svg' />
                      </a>
                    : ''}
            </div>
        </div>
    )
}

export default PendingConnectionDetailItem



// WEBPACK FOOTER //
// ./resources/js/components/PendingConnectionDetailItem.js